<template>
  <div class="modal right fade" :id="objectModalName.system" tabindex="-1" role="dialog" aria-modal="true">
    <div class="modal-dialog" role="document">
<!--      <button type="button" class="close md-close" @click="closeWarning('#'+objectModalName.system)" aria-label="Close"><span aria-hidden="true">&times;</span></button>-->
      <div class="modal-content">

        <div class="modal-header">
          <button type="button" class="close xs-close" data-dismiss="modal" @click="closeWarning('#'+objectModalName.system)">×</button>
          <div class="row w-100">
            <div class="col-md-7 account d-flex">
              <div class="company_img">
                <img src="@/assets/img/c-logo.png" alt="User" class="img-fluid" />
              </div>
              <div>
                <p class="mb-0">System</p>
                <span class="modal-title">{{currentSystem.name}}</span>
                <a href="#" @click.prevent="setEdit(!edit)"><span class="lock"><i class="fa fa-pencil" aria-hidden="true" v-show="!edit"></i><i class="fa fa-lock" aria-hidden="true" v-show="edit"></i></span></a>
              </div>
            </div>
          </div>

        </div>

        <div class="card due-dates">
          <div class="card-body">
            <div class="row" v-if="currentSystem.id">
              <div class="col">
                <span>Name</span>
                <p>{{currentSystem.name}}</p>
              </div>
              <div class="col">
                <span>Abteilung</span>
                <p>{{currentSystem.department}}</p>
              </div>
              <div class="col">
                <span>Berechtigung</span>
                <p>{{currentSystem.authentication}}</p>
              </div>
              <div class="col">
                <span>Weitere Verantwortlichkeiten</span>
                <p>{{currentSystem.other_responsible}}</p>
                <input class="form-control" v-if="!currentSystem.id" v-model="currentSystem.other_responsible" autocomplete="off">
              </div>
            </div>
          </div>
        </div>

        <div class="modal-body">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col">
                  <p class="mt-2 mb-1 text-muted">Name<span class="text-danger">*</span></p>
                  <h4 class="mt-0" v-if="currentSystem.id && !edit">{{currentSystem.name}}</h4>
                  <input class="form-control" v-if="!currentSystem.id || edit" v-model="currentSystem.name" placeholder="Name" autocomplete="off">
                  <span class="error-message text-danger" v-show="v$.currentSystem.name.$errors.length>0">{{ $t('required_field') }}</span>

                  <div class="row">
                    <div class="col-6">
                      <!-- assignee -->
                      <p class="mt-2 mb-1 text-muted">Abteilung</p>
                      <div class="d-flex">
                        <div class="flex-grow-1">
                          <h5 class="mt-1 fs-14" v-if="currentSystem.id && !edit">{{currentSystem.department}}</h5>
                          <div v-show="!currentSystem.id || edit">
                            <select class="form-control select select-single select-system-department allow-create" v-model="currentSystem.department" v-select2>
                              <option value="">--------</option>
                              <option v-for="department in departments" :value="department.text">{{department.text}}</option>
                            </select>
                          </div>
                        </div>
                      </div>
                      <!-- end assignee -->
                    </div> <!-- end col -->
                    <div class="col-6">
                      <!-- assignee -->
                      <p class="mt-2 mb-1 text-muted">Dienstleister</p>
                      <div class="d-flex">
                        <div class="flex-grow-1">
                          <h5 class="mt-1 fs-14" v-if="currentSystem.id && !edit">{{currentSystem.supplier}}</h5>
                          <div v-show="!currentSystem.id || edit">
                            <select class="form-control select select-single select-system-department allow-create" v-model="currentSystem.supplier" v-select2>
                              <option value="">--------</option>
                              <option v-for="supplier in suppliers" :value="supplier.text">{{supplier.text}}</option>
                            </select>
                          </div>
                        </div>
                      </div>
                      <!-- end assignee -->
                    </div> <!-- end col -->
                  </div> <!-- end row -->

                  <div class="row">
                    <div class="col-12">
                      <!-- start due date -->
                      <p class="mt-2 mb-1 text-muted">Weitere Verantwortlichkeit</p>
                      <div class="d-flex">
                        <i class='uil uil-schedule text-success me-1'></i>
                        <div class="flex-grow-1">
                          <h5 class="mt-1 fs-14" v-if="currentSystem.id && !edit">{{currentSystem.other_responsible}}</h5>
                          <input class="form-control" v-if="!currentSystem.id || edit" v-model="currentSystem.other_responsible" autocomplete="off">
                        </div>
                      </div>
                      <!-- end due date -->
                    </div> <!-- end col -->
                  </div> <!-- end row -->

                  <!-- task description -->
                  <div class="row mt-3">
                    <div class="col">
                      <div id="bubble-editor">
                        <p><span class="text-muted dkl-mr-1">Wofür:</span><span class="text-danger">*</span> <span class="font-weight-bold" v-if="currentSystem.id && !edit">{{currentSystem.purpose}}</span>
                          <input class="form-control" v-if="!currentSystem.id || edit" v-model="currentSystem.purpose" autocomplete="off">
                          <span class="error-message text-danger" v-show="v$.currentSystem.purpose.$errors.length>0">{{ $t('required_field') }}</span>
                        </p>
                        <p><span class="text-muted dkl-mr-1">Speicherort/Hosting:</span><span class="text-danger">*</span><span class="font-weight-bold" v-if="currentSystem.id && !edit">{{currentSystem.storage_place}}</span>
                          <input class="form-control" v-if="!currentSystem.id || edit" v-model="currentSystem.storage_place" autocomplete="off">
                          <span class="error-message text-danger" v-show="v$.currentSystem.storage_place.$errors.length>0">{{ $t('required_field') }}</span>
                        </p>
                        <p><span class="text-muted dkl-mr-1">Zugriffe und Rechte sowie Rollenkonzept:</span>
                          <span class="font-weight-bold" v-if="currentSystem.id && !edit">{{currentSystem.authentication}}</span>
                          <input class="form-control" v-if="!currentSystem.id || edit" v-model="currentSystem.authentication" autocomplete="off">
                        </p>
                        <p><span class="text-muted dkl-mr-1">Löschkonzept:</span> <span class="font-weight-bold" v-if="currentSystem.id && !edit">{{currentSystem.deletion}}</span>
                          <input class="form-control" v-if="!currentSystem.id || edit" v-model="currentSystem.deletion" autocomplete="off">
                        </p>
                        <p><span class="text-muted dkl-mr-1">Backup/Datensicherung:</span> <span class="font-weight-bold" v-if="currentSystem.id && !edit">{{currentSystem.backup}}</span>
                          <input class="form-control" v-if="!currentSystem.id || edit" v-model="currentSystem.backup" autocomplete="off">
                        </p>
                        <p><span class="text-muted dkl-mr-1">Anmerkung:</span> <span class="font-weight-bold" v-if="currentSystem.id && !edit">{{currentSystem.remarks}}</span>
                          <textarea class="form-control" v-if="!currentSystem.id || edit" v-model="currentSystem.remarks"></textarea>
                        </p>
                        <p v-if="currentSystem.id"><span class="text-muted dkl-mr-1">Stand/letzte Eintragung:</span> <span class="font-weight-bold">{{currentSystem.modified}}</span></p>
                      </div> <!-- end Snow-editor-->
                    </div> <!-- end col -->
                  </div>
                  <!-- end task description -->

                  <!-- start attachments -->
                  <slot name="fileUpload"></slot>
                  <!-- end attachments -->
                  <!-- comments -->
                  <slot name="comments"></slot>
                  <!-- end comments -->
                </div> <!-- end col -->
              </div> <!-- end row-->
            </div> <!-- end card-body -->
          </div>
        </div>
        <div class="modal-footer" v-if="!currentSystem.id || edit">
          <button type="button" class="border-0 btn btn-primary btn-gradient-primary btn-rounded" @click.prevent="saveSystem" :key="btnEnableKey" :disabled="btnDisabled">Speichern</button>&nbsp;&nbsp;
          <button type="button" class="btn btn-secondary btn-rounded" @click="closeWarning('#'+objectModalName.system)">Abbrechen</button>
        </div>

      </div><!-- modal-content -->
    </div><!-- modal-dialog -->
  </div><!-- modal -->
</template>

<script>
import {service} from '@/utils/request.js';
import {ajaxErrorMessage, closeWarning, getSystems, initSelect2} from '@/utils/index.js';
import { objectModalName } from '@/utils/enums.js';
import {mapState, mapMutations} from 'vuex';
import datePicker from 'vue-bootstrap-datetimepicker';
import { Uploader, Button } from 'vant';
import { useVuelidate } from '@vuelidate/core';
import { required } from '@vuelidate/validators';

export default {
  name: "SystemComponent",
  props: {
    currentSystem: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      objectModalName: objectModalName,
      btnEnableKey: 1,
      btnDisabled: false,
    }
  },
  mounted() {
    initSelect2()
    $('#related_system').on('hidden.bs.modal', () => {
      this.setEdit(false)
    })
    $('#related_system').on('shown.bs.modal', () => {
      $('#' + this.objectModalName.system + ' .select-system-department').val(this.currentSystem.department).trigger('change')
      $('#' + this.objectModalName.system + ' .select-system-supplier').val(this.currentSystem.supplier).trigger('change')
    })
  },
  beforeDestroy() {
    $('#related_system').off('shown.bs.modal')
    $('#related_system').off('hidden.bs.modal')
  },
  computed: {
    ...mapState({
      accountid: state => state.account.accountid,
      userName: state => state.user.username,
      account: state => state.account,
      userID: state => state.user.id,
      edit: state => state.app.edit,
      departments: state => state.account.departments,
      suppliers: state => state.account.suppliers,
      systems: state => state.account.systems,
      modalDirty: state => state.app.modalDirty,
    }),
  },
  validations() {
    return {
      currentSystem: {
        name: {required, $lazy: true},
        purpose: {required, $lazy: true},
        storage_place: {required, $lazy: true},
      },
    }
  },
  setup() {
    return {
      v$: useVuelidate()
    }
  },
  watch:{
    currentSystem: {
      handler: function (newValue, oldVal) {
        if (!this.modalDirty) this.setModalDirty(true)
      },
      deep: true
    }
  },
  methods: {
    ...mapMutations({setEdit: 'SET_EDIT', setModalDirty: 'SET_MODALDIRTY'}),
    closeWarning,
    async saveSystem() {
      if (this.currentSystem.customer === '') this.currentSystem.customer = this.account.name
      if (this.currentSystem.modified_by === '') this.currentSystem.modified_by = this.userName
      const isValid = await this.v$.currentSystem.$validate()
      if (!isValid) {
        this.$vToastify.error('Bitte fehlende Felder vervollständigen!')
        return
      }
      if (!this.currentSystem.id && this.systems.some(system => system.text === this.currentSystem.name)) {
        this.$vToastify.error('System mit gleichen Name existiert bereits!')
        return
      }
      this.btnDisabled = true
      let url = 'todos/v1/create_system/'
      let newSystem = true
      if (this.currentSystem.id) {
        url = `todos/v1/update_system/${this.currentSystem.id}/`
        newSystem = false
      }
      service.request({
        url: url,
        method: 'POST',
        responseType: 'json',
        data: this.currentSystem
      }).then((response) => {
        this.setModalDirty(false)
        this.v$.$reset()
        this.btnDisabled = false
        // getSystems(this.accountid, true)
        this.$emit('systemUpdated', response.data)
        $('#' + this.objectModalName.system).modal('hide')
        this.$vToastify.success('System ist erfolgreich gespeichert!')
      }).catch(error => {
        this.btnDisabled = false
        this.$vToastify.error(ajaxErrorMessage(error))
      })
    },
  }
}
</script>

<style scoped>
.close {
  right: 25px;
  top: 20px;
}
</style>
